var map = {
	"./000.png": "./src/assets/picture/IChing/000.png",
	"./001.png": "./src/assets/picture/IChing/001.png",
	"./002.png": "./src/assets/picture/IChing/002.png",
	"./003.png": "./src/assets/picture/IChing/003.png",
	"./004.png": "./src/assets/picture/IChing/004.png",
	"./005.png": "./src/assets/picture/IChing/005.png",
	"./006.png": "./src/assets/picture/IChing/006.png",
	"./007.png": "./src/assets/picture/IChing/007.png",
	"./008.png": "./src/assets/picture/IChing/008.png",
	"./009.png": "./src/assets/picture/IChing/009.png",
	"./010.png": "./src/assets/picture/IChing/010.png",
	"./011.png": "./src/assets/picture/IChing/011.png",
	"./012.png": "./src/assets/picture/IChing/012.png",
	"./013.png": "./src/assets/picture/IChing/013.png",
	"./014.png": "./src/assets/picture/IChing/014.png",
	"./015.png": "./src/assets/picture/IChing/015.png",
	"./016.png": "./src/assets/picture/IChing/016.png",
	"./017.png": "./src/assets/picture/IChing/017.png",
	"./018.png": "./src/assets/picture/IChing/018.png",
	"./019.png": "./src/assets/picture/IChing/019.png",
	"./020.png": "./src/assets/picture/IChing/020.png",
	"./021.png": "./src/assets/picture/IChing/021.png",
	"./022.png": "./src/assets/picture/IChing/022.png",
	"./023.png": "./src/assets/picture/IChing/023.png",
	"./024.png": "./src/assets/picture/IChing/024.png",
	"./025.png": "./src/assets/picture/IChing/025.png",
	"./026.png": "./src/assets/picture/IChing/026.png",
	"./027.png": "./src/assets/picture/IChing/027.png",
	"./028.png": "./src/assets/picture/IChing/028.png",
	"./029.png": "./src/assets/picture/IChing/029.png",
	"./030.png": "./src/assets/picture/IChing/030.png",
	"./031.png": "./src/assets/picture/IChing/031.png",
	"./032.png": "./src/assets/picture/IChing/032.png",
	"./033.png": "./src/assets/picture/IChing/033.png",
	"./034.png": "./src/assets/picture/IChing/034.png",
	"./035.png": "./src/assets/picture/IChing/035.png",
	"./036.png": "./src/assets/picture/IChing/036.png",
	"./037.png": "./src/assets/picture/IChing/037.png",
	"./038.png": "./src/assets/picture/IChing/038.png",
	"./039.png": "./src/assets/picture/IChing/039.png",
	"./040.png": "./src/assets/picture/IChing/040.png",
	"./041.png": "./src/assets/picture/IChing/041.png",
	"./042.png": "./src/assets/picture/IChing/042.png",
	"./043.png": "./src/assets/picture/IChing/043.png",
	"./044.png": "./src/assets/picture/IChing/044.png",
	"./045.png": "./src/assets/picture/IChing/045.png",
	"./046.png": "./src/assets/picture/IChing/046.png",
	"./047.png": "./src/assets/picture/IChing/047.png",
	"./048.png": "./src/assets/picture/IChing/048.png",
	"./049.png": "./src/assets/picture/IChing/049.png",
	"./050.png": "./src/assets/picture/IChing/050.png",
	"./051.png": "./src/assets/picture/IChing/051.png",
	"./052.png": "./src/assets/picture/IChing/052.png",
	"./053.png": "./src/assets/picture/IChing/053.png",
	"./054.png": "./src/assets/picture/IChing/054.png",
	"./055.png": "./src/assets/picture/IChing/055.png",
	"./056.png": "./src/assets/picture/IChing/056.png",
	"./057.png": "./src/assets/picture/IChing/057.png",
	"./058.png": "./src/assets/picture/IChing/058.png",
	"./059.png": "./src/assets/picture/IChing/059.png",
	"./060.png": "./src/assets/picture/IChing/060.png",
	"./061.png": "./src/assets/picture/IChing/061.png",
	"./062.png": "./src/assets/picture/IChing/062.png",
	"./063.png": "./src/assets/picture/IChing/063.png",
	"./064.png": "./src/assets/picture/IChing/064.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/picture/IChing sync \\.png$";